<template>
	<div class="rel">
		<!--head-->
		<!-- <div class="head-tit clear">
			<div class="w1200 clear">
				<p class="fr" style="color: #FF0000;">
					<img src="../assets/img/headphone-icon.png" /> 咨询热线：4009-303-555
				</p>
				<a href="javascript:void(0)"><img src="../assets/img/IPv6.png" alt="" style="width: 35px;"></a>
			</div>
		</div> -->
		<el-header class="doc-header" height="">
			<!---头部导航-->
			<div class="doc-header-meun clear">
				<p class="fl" style="height: 60px;"><a href="#/"><img src="../assets/img/doc_login.png" /></a></p>
				<el-menu class="meun fl el-menu-demo" :default-active="$route.path" mode="horizontal" @select="handleSelect">
					<el-menu-item index="/productDoc">
						<a href="#/productDoc">产品文档</a>
					</el-menu-item>
					<el-menu-item index="/apiDocBak">
						<a href="#/apiDocBak">API文档</a>
					</el-menu-item>
					<el-menu-item index="/techDoc">
						<a href="#/techDoc">技术规范</a>
					</el-menu-item>
					<el-menu-item index="/debugTool">
						<a href="#/debugTool">开发&联调工具</a>
					</el-menu-item>						
				</el-menu>				
			</div>
		</el-header>
	</div>
</template>

<script>
	export default {
		methods: {
			handleSelect(key, keyPath) {
//				console.log(key, keyPath);
			}
		}
	}
</script>

<style lang="less">
	.el-dropdown-menu__item a {
		color: #333;
	}
		
	.doc-header {
		position: absolute;
		// top: 30px;
		left: 0;
		width: 100%;
		height: 60px;
		background: #fff !important;
		z-index: 9;
		// border-bottom: #646566 solid 0.1px;
		box-shadow: 0px -1.5px 1.5px #F5F5F5 inset;
		.doc-header-meun {
			width: 100%;
			margin: 0 auto;
			p>a img {
				padding: 10px 10px;
				margin-right: 20px;
				color: #FF0000;
			}
			.meun {
				background: none;
				border-bottom: none;
				.el-menu-item {
					padding: 0px;
					height: 60px;
					width: 115px;
					line-height: 60px;
					color: #000000;
					font-size: 16px;
					text-align: center;
					border-bottom: none;
					.el-menu-item:not(.is-disabled):focus,
					.el-menu-item:not(.is-disabled):hover {
						color: #fff;
						background: #4d78dd;
					}
				}
				li a {
					display: block;
				}
				.is-active,
				li:hover {
					// background: #4d78dd;
					color: #409eff !important;
					border-bottom: none !important;
					font-weight: 700;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/doc_head.vue